module.exports = __webpack_public_path__ + "img/2.d0f22871.png";